import { z } from '../utils/zod.js';
import { adminActorSchema } from './audit-logs.js';
import { adminPageResponse, adminPaginationQuerySchema } from './pagination.js';
export const ADMIN_TIMELINE_KINDS = ['audit', 'org_event', 'signing'];
export const adminTimelineKindSchema = z.enum(ADMIN_TIMELINE_KINDS);
export const adminTimelineItemSchema = z.object({
    id: z.string().uuid(),
    at: z.string().datetime(),
    kind: adminTimelineKindSchema,
    action: z.string(),
    actor: adminActorSchema.optional(),
    summary: z.string(),
    payload: z.unknown().optional(),
});
export const adminTimelineQuerySchema = adminPaginationQuerySchema;
export const adminTimelineResponseSchema = adminPageResponse(adminTimelineItemSchema);
